import BaseReducer from "./BaseReducer";

class CustomerReviewFiltersReducer extends BaseReducer {
  domain = "CustomerReviewFilters";
  type = "Modal";

  initialState = {
    id: null,
    fromDate: null,
    toDate: null,
    dateRange: "",
    reviewTypeIds: null,
    reviewStatusTypeIds: null,
    filterReason: null,
    triggeredAlert: null,
    netLoss: "",
    duration: "",
    spend: "",
    filterReviewStatus: null,
    showFilters: false,

    // Interactions
    customerInteractionReasonId: null,
    triggeredByAlert: null,

    // Customer Sessions
    durationFrom: null,
    durationTo: null,
    netLossFrom: null,
    netLossTo: null,
    spendFrom: null,
    spendTo: null,

    // Customer Reviews
    isEscalated: false,

    // Metadata
    reviewTypes: [
      { id: 1, name: "Basic Review" },
      { id: 2, name: "Manager Review" },
    ],
  };
}

const reducer = new CustomerReviewFiltersReducer();

export default reducer;
